<script>
  import {mapState, mapMutations} from "vuex";
  import DcbService from "@/api/services/dcbService";
  import UtilsService from "@/api/services/utilsService";
  import setUserSessionData from "@/functions/setUserSessionData";
  import {isVodacom} from "@/config";
  import DepService from "@/api/services/depService";
  import CarouselComponent from "@/views/components/CarouselComponent.vue";

  export default {
    name: "RequestOtpView",
    components: {CarouselComponent},
    data() {
      return {
        msisdn: undefined,
        isValidNumber: null,
        isNotOnNetwork: false,
        isEmpty: false,
        hasText: false
      }
    },
    computed: {
      ...mapState(['brandConfig', 'serviceId', 'productId','currentSeason']),
    },
    methods: {
      ...mapMutations(['setMsisdn', 'setUser', 'setServiceId', 'setIsLoading']),
      async continueClicked() {
        this.isEmpty = false;
        this.hasText = false;
        this.isValidNumber = null;

        if (!this.msisdn || this.msisdn.trim() === '') {
          this.isEmpty = true;
          return;
        }

        if (/[a-zA-Z]/.test(this.msisdn)) {
          this.hasText = true;
          return;
        }

        this.setIsLoading(true);
        this.filterUserMsisdn();
        if (this.isCellNumberValid(this.msisdn)) {

          await this.getMultiTierService();

          this.setMsisdn(this.msisdn); //stores
          sessionStorage.setItem("msisdn",(this.msisdn));

           await DepService.requestOtp(this.msisdn, this.productId);
          this.$router.push('/submit-otp');
        } else {
          this.msisdn = '';
        }
        this.setIsLoading(false)
      },

      isCellNumberValid(cellNumber) {
        if (cellNumber.length === 10 || cellNumber.length === 11) {
          let regex = /(?:^[0-9\s]{1,9}?$|(?:0|\+27|27)\d{2}[\s-]?\d{3}[\s-]?\d{4})/;
          if (regex.test(cellNumber)) {
            this.isValidNumber = true;
            return true
          } else {
            this.isValidNumber = false;
            return false
          }
        } else {
          this.isValidNumber = false;
        }
      },
      filterUserMsisdn() {
        const noPlus = this.msisdn.replace(/[+]/g, "");
        const noZero = noPlus.replace(/^[0]/, "27");
        this.msisdn = noZero.replace(/\s/g, '');
      },
      async getMultiTierService() {
        let getMultiTierServiceResponse = (await DepService.getUserViaProductId(this.msisdn, this.productId)).data.user;
        const serviceId = this.getServiceIdByDescription(getMultiTierServiceResponse)
        setUserSessionData(this.msisdn, JSON.stringify(getMultiTierServiceResponse));
        this.setServiceId(serviceId);
      },
      getServiceIdByDescription(user) {
        return user.serviceId
      },
      termsConditionsClicked() {
        this.$router.push('/terms-and-conditions');
      },
    },
  }
</script>

<template>
  <div class="d-flex flex-column justify-content-start align-items-center col-12 mt-5 position-relative">
    <div class="d-flex flex-column justify-content-center align-items-start col-11">
      <img src="@/assets/onboarding/onboarding-logo.png" class="col-5" />
    </div>
    <div class="d-flex flex-column justify-content-start align-items-end col-11" >
      <img src="@/assets/onboarding/onboarding-img.png" class="col-8" />
    </div>
    <div class="text-center fw-bold col-7 fs-6 mt-3 mb-5" style="color: #000F56">
      Please enter your mobile number to join Mzansi Rhythm
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center col-12 gap-3">
    <input @keyup.enter="continueClicked()" v-model="msisdn" class="col-11 msisdn-input p-4 text-center" inputmode="numeric"  placeholder="Enter your phone number"/>
      <div class="invalid-msisdn mt-2" v-if="isEmpty">Please enter your number.</div>
      <div class="invalid-msisdn mt-2" v-if="hasText">Please enter numbers only, no letters.</div>
      <div class="invalid-msisdn mt-2" v-if="isValidNumber === false">Invalid cellphone number. Please try again!</div>
      <div class="invalid-msisdn mt-2" v-if="isNotOnNetwork">Incorrect network provider!</div>
      <div class="col-11 p-4 continue-btn text-center fw-bold fs-6" @click="continueClicked()">Continue</div>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center col-11 mt-3">
      <CarouselComponent :season="currentSeason" />
    </div>
    <div class="d-flex flex-column justify-content-center text-center align-items-center col-7 mb-4 mt-4"  style="color: #000F56">
      By entering your number you agree to our privacy policy and <span class="text-decoration-underline" @click="this.$router.push('/terms')">Terms & Conditions.</span>
    </div>
  </div>

</template>

<style scoped>
  .msisdn-input {
    border-radius: 27px;
    border: 1px solid #CCC;
  }
  .continue-btn {
    border-radius: 30px;
    background: #FFCB05;
  }
  .invalid-msisdn {
    font-size: 12px;
    color: #ff0008;
  }
</style>